import React, { useState } from 'react';
import { Modal, Form, Button, Alert } from 'react-bootstrap';
import { loginCliente, registerCliente, vincularClienteBrand, loginGoogleCliente } from '../services/api';
import { getCampaignId } from '../utils/campaignContext';

import './ModalMobile.css';

function LoginModal({ show, onHide, onLogin, dadosPreenchidos = {}, brandLogoUrl = null }) {
  const [viewMode, setViewMode] = useState('login');
  const [formData, setFormData] = useState({
    cpf: dadosPreenchidos.cpf || '',
    senha: '',
    nome: dadosPreenchidos.nome || '',
    telefone: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');



  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
    setError('');
  };

  const formatCPF = (value) => {
    return value.replace(/\D/g, '').replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  };

  const formatPhone = (value) => {
    return value.replace(/\D/g, '').replace(/(\d{2})(\d{5})(\d{4})/, '($1)$2-$3');
  };

  const validateCPF = (cpf) => {
    cpf = cpf.replace(/\D/g, '');
    
    if (cpf.length !== 11) return false;
    if (/^(\d)\1+$/.test(cpf)) return false;
    
    let sum = 0;
    for (let i = 0; i < 9; i++) {
      sum += parseInt(cpf.charAt(i)) * (10 - i);
    }
    let remainder = (sum * 10) % 11;
    if (remainder === 10 || remainder === 11) remainder = 0;
    if (remainder !== parseInt(cpf.charAt(9))) return false;
    
    sum = 0;
    for (let i = 0; i < 10; i++) {
      sum += parseInt(cpf.charAt(i)) * (11 - i);
    }
    remainder = (sum * 10) % 11;
    if (remainder === 10 || remainder === 11) remainder = 0;
    if (remainder !== parseInt(cpf.charAt(10))) return false;
    
    return true;
  };

  const getBrandFromSubdomain = () => {
    const host = window.location.host;
    const parts = host.split('.');
    return parts[0].includes('localhost') ? 'gente-bonita' : parts[0];
  };





  const handleLogin = async () => {
    if (!formData.cpf || !formData.senha) {
      setError('Preencha CPF e senha');
      return;
    }

    if (!validateCPF(formData.cpf)) {
      setError('CPF inválido');
      return;
    }

    setLoading(true);
    try {
      const brand = getBrandFromSubdomain();
      
      // Login global (sem brand)
      const resultado = await loginCliente(formData.cpf, formData.senha);
      
      if (!resultado || !resultado.success) {
        setError(resultado?.message || 'Erro ao fazer login');
        return;
      }
      
      // Vincular cliente à brand
      await vincularClienteBrand(resultado.token, brand);
      
      localStorage.setItem('sitri_token', resultado.token);
      
      // Verificar se há pedido anônimo para vincular
      const { obterPedidoAnonimo, limparPedidoAnonimo } = await import('../services/pedidoAnonimo');
      const { vincularPedidoAnonimo } = await import('../services/api');
      const pedidoAnonimo = obterPedidoAnonimo();
      
      
      if (pedidoAnonimo && pedidoAnonimo.comandaId) {
        
        try {
          await vincularPedidoAnonimo(resultado.token, {
            comandaId: pedidoAnonimo.comandaId,
            brand: pedidoAnonimo.brand
          });
          
          // Disparar evento customizado para mostrar toast
          window.dispatchEvent(new CustomEvent('pedidoVinculado', {
            detail: pedidoAnonimo
          }));
          
          limparPedidoAnonimo();
        } catch (error) {
        }
      }
      
      onLogin(resultado.usuario);
      onHide();
      resetForm();
    } catch (error) {
      setError('Erro ao fazer login. Verifique suas credenciais.');
    } finally {
      setLoading(false);
    }
  };

  const handleRegister = async () => {
    if (!formData.cpf || !formData.nome || !formData.telefone || !formData.senha) {
      setError('Preencha todos os campos');
      return;
    }

    if (!validateCPF(formData.cpf)) {
      setError('CPF inválido');
      return;
    }

    const phone = formData.telefone.replace(/\D/g, '');
    if (phone.length < 11) {
      setError('Telefone inválido');
      return;
    }

    setLoading(true);
    try {
      const brand = getBrandFromSubdomain();
      let resultado;
      
      // Cadastro normal
      resultado = await registerCliente({
        cpf: formData.cpf,
        nome: formData.nome,
        telefone: formData.telefone,
        senha: formData.senha,
        email: formData.email,
        ...(getCampaignId() && { campanha_id: getCampaignId(), brand })
      });
      
      if (!resultado || !resultado.success) {
        setError(resultado?.message || 'Erro ao criar conta');
        return;
      }
      
      // Vincular cliente à brand
      await vincularClienteBrand(resultado.token, brand);
      
      localStorage.setItem('sitri_token', resultado.token);
      
      // Verificar se há pedido anônimo para vincular
      const { obterPedidoAnonimo, limparPedidoAnonimo } = await import('../services/pedidoAnonimo');
      const { vincularPedidoAnonimo } = await import('../services/api');
      const pedidoAnonimo = obterPedidoAnonimo();
      
      
      if (pedidoAnonimo && pedidoAnonimo.comandaId) {
        
        try {
          await vincularPedidoAnonimo(resultado.token, {
            comandaId: pedidoAnonimo.comandaId,
            brand: pedidoAnonimo.brand
          });
          
          // Disparar evento customizado para mostrar toast
          window.dispatchEvent(new CustomEvent('pedidoVinculado', {
            detail: pedidoAnonimo
          }));
          
          limparPedidoAnonimo();
        } catch (error) {
        }
      }
      
      onLogin(resultado.usuario);
      onHide();
      resetForm();
    } catch (error) {
      setError('Erro ao criar conta. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };



  const handleGoogleCredentialResponse = async (response) => {
    setLoading(true);
    try {
      const resultado = await loginGoogleCliente(response.credential);
      
      if (resultado.success) {
        // Login bem-sucedido
        const brand = getBrandFromSubdomain();
        await vincularClienteBrand(resultado.token, brand);
        localStorage.setItem('sitri_token', resultado.token);
        
        // Verificar pedido anônimo
        const { obterPedidoAnonimo, limparPedidoAnonimo } = await import('../services/pedidoAnonimo');
        const { vincularPedidoAnonimo } = await import('../services/api');
        const pedidoAnonimo = obterPedidoAnonimo();
        
        if (pedidoAnonimo && pedidoAnonimo.comandaId) {
          try {
            await vincularPedidoAnonimo(resultado.token, {
              comandaId: pedidoAnonimo.comandaId,
              brand: pedidoAnonimo.brand
            });
            
            window.dispatchEvent(new CustomEvent('pedidoVinculado', {
              detail: pedidoAnonimo
            }));
            
            limparPedidoAnonimo();
          } catch (error) {
            // Erro silencioso
          }
        }
        
        onLogin(resultado.usuario);
        onHide();
        resetForm();
      } else if (resultado.requiresCompletion) {
        // Login direto sem completar dados
        const brand = getBrandFromSubdomain();
        await vincularClienteBrand(resultado.token, brand);
        localStorage.setItem('sitri_token', resultado.token);
        
        onLogin(resultado.usuario || resultado.existingData);
        onHide();
        resetForm();
      } else {
        setError(resultado.message || 'Erro no login com Google');
      }
    } catch (error) {
      setError('Erro ao fazer login com Google');
    } finally {
      setLoading(false);
    }
  };



  const resetForm = () => {
    setFormData({
      cpf: dadosPreenchidos.cpf || '',
      senha: '',
      nome: dadosPreenchidos.nome || '',
      telefone: ''
    });
    setError('');
    setViewMode('login');
  };

  // Atualizar formData quando dadosPreenchidos mudar
  React.useEffect(() => {
    if (show && (dadosPreenchidos.cpf || dadosPreenchidos.nome)) {
      setFormData(prev => ({
        ...prev,
        cpf: dadosPreenchidos.cpf || prev.cpf,
        nome: dadosPreenchidos.nome || prev.nome
      }));
    }
  }, [show, dadosPreenchidos]);

  const handleClose = () => {
    resetForm();
    onHide();
  };



  return (
    <>
      <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton></Modal.Header>
      
      <Modal.Body style={{backgroundColor:'#f3f4f6'}}>
        <div className="text-center mb-3">
          <div className="d-flex justify-content-center align-items-center mb-3" style={{position: 'relative', width: '106px', height: '60px', margin: '0px auto'}}>
            {brandLogoUrl && (
              <>
                <img 
                  src="https://grubicons.s3.us-east-1.amazonaws.com/logo-grub.png" 
                  alt="Logo GRUB" 
                  style={{ 
                    position: 'absolute',
                    right: '0',
                    width: '60px', 
                    height: '60px', 
                    borderRadius: '50%',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    zIndex: 1
                  }}
                />
                <img 
                  src={`https://grubupload.s3.amazonaws.com/${brandLogoUrl}`}
                  alt="Logo da marca" 
                  style={{ 
                    position: 'absolute',
                    left: '0',
                    width: '60px', 
                    height: '60px', 
                    borderRadius: '50%', 
                    objectFit: 'cover',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                  }}
                  onError={(e) => { e.target.style.display = 'none'; }}
                />
              </>
            )}
          </div>
          
          {viewMode === 'login' ? (
            <>
              <h6 style={{fontSize:'0.95rem', fontWeight:700, color:'#1a1a1a'}}>Acesse sua conta GRUB®</h6>
              <p className="text-muted" style={{fontSize:'0.85rem'}}>Insira seus dados para continuar</p>
            </>
          ) : (
            <>
              <h6 style={{fontSize:'0.95rem', fontWeight:700, color:'#1a1a1a'}}>Criar conta GRUB®</h6>
              <p className="text-muted" style={{fontSize:'0.85rem'}}>Crie sua conta e aproveite benefícios exclusivos</p>
            </>
          )}
        </div>

        {error && (
          <Alert variant="danger" className="py-2">
            <small>{error}</small>
          </Alert>
        )}

        <div className="mb-3">
          <Button
            onClick={() => {
              const brand = getBrandFromSubdomain();
              const returnUrl = window.location.href;
              // Salvar returnUrl no localStorage como fallback para o AuthSuccess
              localStorage.setItem('sitri_returnUrl', returnUrl);
              const googleAuthUrl = `https://auth.grub.digital/public/oauth/google?brand=${brand}&returnUrl=${encodeURIComponent(returnUrl)}`;
              window.location.href = googleAuthUrl;
            }}
            disabled={loading}
            variant="outline-secondary"
            className="w-100 d-flex align-items-center justify-content-center"
            style={{
              borderRadius: '8px',
              padding: '12px',
              fontSize: '0.9rem',
              fontWeight: 500,
              border: '1px solid #dadce0'
            }}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" className="me-2">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            {viewMode === 'login' ? 'Entrar com Google' : 'Cadastrar com Google'}
          </Button>
        </div>

        <div className="text-center mb-3">
          <small className="text-muted">ou</small>
        </div>

        <div className="p-3 mb-3" style={{background:'#fff', border:'1px solid #e5e7eb', borderRadius:'12px', boxShadow:'0 1px 2px rgba(0,0,0,0.04)'}}>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label className="small">CPF</Form.Label>
            <Form.Control
              type="text"
              placeholder="000.000.000-00"
              value={formatCPF(formData.cpf)}
              onChange={(e) => handleInputChange('cpf', e.target.value.replace(/\D/g, ''))}
              maxLength={14}
              size="sm"
            />
          </Form.Group>

          {viewMode === 'register' && (
            <>
              <Form.Group className="mb-3">
                <Form.Label className="small">Nome completo</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Seu nome completo"
                  value={formData.nome}
                  onChange={(e) => handleInputChange('nome', e.target.value)}
                  size="sm"
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label className="small">Telefone</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="(00)00000-0000"
                  value={formatPhone(formData.telefone)}
                  onChange={(e) => handleInputChange('telefone', e.target.value.replace(/\D/g, ''))}
                  maxLength={14}
                  size="sm"
                />
              </Form.Group>
            </>
          )}

          <Form.Group className="mb-2">
            <Form.Label className="small">Senha</Form.Label>
            <Form.Control
              type="password"
              placeholder="Sua senha"
              value={formData.senha}
              onChange={(e) => handleInputChange('senha', e.target.value)}
              size="sm"
            />
          </Form.Group>

          <div className="d-grid gap-2 mt-3">
            <Button
              onClick={viewMode === 'login' ? handleLogin : handleRegister}
              disabled={loading}
              size="sm"
              style={{
                backgroundColor: '#006affff',
                border: 'none',
                borderRadius: '12px',
                padding: '12px',
                fontSize: '0.9rem',
                fontWeight: 600
              }}
            >
              {loading ? 'Aguarde...' : (viewMode === 'login' ? 'Entrar' : 'Criar Conta')}
            </Button>
          </div>
        </Form>
        </div>

        <div className="text-center mt-3">
          <Button
            variant="link"
            onClick={() => setViewMode(viewMode === 'login' ? 'register' : 'login')}
            className="p-0 text-decoration-none"
            size="sm"
          >
            {viewMode === 'login' 
              ? 'Não tem conta? Criar uma nova' 
              : 'Já tem conta? Fazer login'
            }
          </Button>
        </div>

        <div className="text-center mt-3">
          <img 
            src="https://grubicons.s3.us-east-1.amazonaws.com/powered-by-grub.png" 
            alt="Powered by GRUB" 
            style={{ width: '150px' }}
          />
        </div>
      </Modal.Body>
      </Modal>

    </>
  );
}

export default LoginModal;
